/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Aai20SchemaDefinition } from '../v2/models/Aai20SchemaDefinition';
import { IAaiVisitor } from '../visitors/IAaiVisitor';
import { JsonCompat } from '../../compat/JsonCompat';
import { Node } from '../../core/models/Node';
import { Components } from '../../core/models/common/Components';
import { IVisitor } from '../../core/visitors/IVisitor';
import { AaiSchema } from './AaiSchema';
import { AaiMessage } from './AaiMessage';
import { AaiSecurityScheme } from './AaiSecurityScheme';
import { AaiParameter } from './AaiParameter';
import { AaiCorrelationId } from './AaiCorrelationId';
import { AaiOperationTraitDefinition } from './AaiOperationTraitDefinition';
import { AaiMessageTraitDefinition } from './AaiMessageTraitDefinition';
import { AaiServerBindingsDefinition } from './AaiServerBindingsDefinition';
import { AaiChannelBindingsDefinition } from './AaiChannelBindingsDefinition';
import { AaiOperationBindingsDefinition } from './AaiOperationBindingsDefinition';
import { AaiMessageBindingsDefinition } from './AaiMessageBindingsDefinition';
import { Document } from '../../core/models/Document';

/**
 * Constructor.
 * @param {Node} parent
 * @class
 * @extends Components
 * @author Jakub Senko <jsenko@redhat.com>
 */
export abstract class AaiComponents extends Components {
    public schemas : any;

    public messages : any;

    public securitySchemes : any;

    public parameters : any;

    public correlationIds : any;

    public operationTraits : any;

    public messageTraits : any;

    public serverBindings : any;

    public channelBindings : any;

    public operationBindings : any;

    public messageBindings : any;

    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super();
            this.schemas = <any>({});
            this.messages = <any>({});
            this.securitySchemes = <any>({});
            this.parameters = <any>({});
            this.correlationIds = <any>({});
            this.operationTraits = <any>({});
            this.messageTraits = <any>({});
            this.serverBindings = <any>({});
            this.channelBindings = <any>({});
            this.operationBindings = <any>({});
            this.messageBindings = <any>({});
            (() => {
                if(parent != null) {
                    this._parent = parent;
                    this._ownerDocument = parent.ownerDocument();
                }
            })();
        } else if(parent === undefined) {
            let __args = arguments;
            super();
            this.schemas = <any>({});
            this.messages = <any>({});
            this.securitySchemes = <any>({});
            this.parameters = <any>({});
            this.correlationIds = <any>({});
            this.operationTraits = <any>({});
            this.messageTraits = <any>({});
            this.serverBindings = <any>({});
            this.channelBindings = <any>({});
            this.operationBindings = <any>({});
            this.messageBindings = <any>({});
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let v : IAaiVisitor = <IAaiVisitor><any>visitor;
        v.visitComponents(this);
    }

    public getMessagesList() : Array<AaiMessage> {
        return JsonCompat.mapToList<any>(this.messages);
    }

    public getSecuritySchemesList() : Array<AaiSecurityScheme> {
        return JsonCompat.mapToList<any>(this.securitySchemes);
    }

    public getParametersList() : Array<AaiParameter> {
        return JsonCompat.mapToList<any>(this.parameters);
    }

    public getCorrelationIdsList() : Array<AaiCorrelationId> {
        return JsonCompat.mapToList<any>(this.correlationIds);
    }

    public getOperationTraitDefinitionsList() : Array<AaiOperationTraitDefinition> {
        return JsonCompat.mapToList<any>(this.operationTraits);
    }

    public getMessageTraitDefinitionsList() : Array<AaiMessageTraitDefinition> {
        return JsonCompat.mapToList<any>(this.messageTraits);
    }

    public getServerBindingsDefinitionList() : Array<AaiServerBindingsDefinition> {
        return JsonCompat.mapToList<any>(this.serverBindings);
    }

    public getChannelBindingsDefinitionList() : Array<AaiChannelBindingsDefinition> {
        return JsonCompat.mapToList<any>(this.channelBindings);
    }

    public getOperationBindingsDefinitionList() : Array<AaiOperationBindingsDefinition> {
        return JsonCompat.mapToList<any>(this.operationBindings);
    }

    public getMessageBindingsDefinitionList() : Array<AaiMessageBindingsDefinition> {
        return JsonCompat.mapToList<any>(this.messageBindings);
    }

    public addSchemaDefinition(key : string, value : AaiSchema) {
        if(this.schemas == null) this.schemas = <any>({});
        /* put */(this.schemas[key] = value);
    }

    /**
     * Gets a single schema definition by name.
     * @param {string} name
     * @return {AaiSchema}
     */
    public getSchemaDefinition(name : string) : AaiSchema {
        if(this.schemas != null) {
            return /* get */((m,k) => m[k]===undefined?null:m[k])(this.schemas, name);
        }
        return null;
    }

    /**
     * Removes a single schema definition and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {AaiSchema}
     */
    public removeSchemaDefinition(name : string) : AaiSchema {
        return /* remove */(map => { let deleted = this.schemas[name];delete this.schemas[name];return deleted;})(this.schemas);
    }

    /**
     * Gets a list of all schema definitions.
     * @return {AaiSchema[]}
     */
    public getSchemaDefinitions() : Array<AaiSchema> {
        let rval : Array<AaiSchema> = <any>([]);
        if(this.schemas != null) {
            /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.schemas));
        }
        return rval;
    }

    public addMessage(key : string, value : AaiMessage) {
        if(this.messages == null) this.messages = <any>({});
        /* put */(this.messages[key] = value);
    }

    public getMessage(name : string) : AaiMessage {
        if(this.messages != null) {
            return /* get */((m,k) => m[k]===undefined?null:m[k])(this.messages, name);
        }
        return null;
    }

    public removeMessage(name : string) : AaiMessage {
        if(this.messages != null) {
            return /* remove */(map => { let deleted = this.messages[name];delete this.messages[name];return deleted;})(this.messages);
        }
        return null;
    }

    public addSecurityScheme(key : string, value : AaiSecurityScheme) {
        if(this.securitySchemes == null) this.securitySchemes = <any>({});
        /* put */(this.securitySchemes[key] = value);
    }

    public getSecurityScheme(name : string) : AaiSecurityScheme {
        if(this.securitySchemes != null) return /* get */((m,k) => m[k]===undefined?null:m[k])(this.securitySchemes, name);
        return null;
    }

    public removeSecurityScheme(name : string) : AaiSecurityScheme {
        if(this.securitySchemes != null) return /* remove */(map => { let deleted = this.securitySchemes[name];delete this.securitySchemes[name];return deleted;})(this.securitySchemes);
        return null;
    }

    public addParameter(key : string, value : AaiParameter) {
        if(this.parameters == null) this.parameters = <any>({});
        /* put */(this.parameters[key] = value);
    }

    public addCorrelationId(key : string, value : AaiCorrelationId) {
        if(this.correlationIds == null) this.correlationIds = <any>({});
        /* put */(this.correlationIds[key] = value);
    }

    public addMessageTraitDefinition(key : string, value : AaiMessageTraitDefinition) {
        if(this.messageTraits == null) this.messageTraits = <any>({});
        /* put */(this.messageTraits[key] = value);
    }

    public getMessageTraitDefinition(name : string) : AaiMessageTraitDefinition {
        if(this.messageTraits != null) {
            return /* get */((m,k) => m[k]===undefined?null:m[k])(this.messageTraits, name);
        }
        return null;
    }

    public removeMessageTraitDefinition(name : string) : AaiMessageTraitDefinition {
        if(this.messageTraits != null) {
            return /* remove */(map => { let deleted = this.messageTraits[name];delete this.messageTraits[name];return deleted;})(this.messageTraits);
        }
        return null;
    }

    public addOperationTraitDefinition(key : string, value : AaiOperationTraitDefinition) {
        if(this.operationTraits == null) this.operationTraits = <any>({});
        /* put */(this.operationTraits[key] = value);
    }

    public getOperationTraitDefinition(name : string) : AaiOperationTraitDefinition {
        if(this.operationTraits != null) {
            return /* get */((m,k) => m[k]===undefined?null:m[k])(this.operationTraits, name);
        }
        return null;
    }

    public removeOperationTraitDefinition(name : string) : AaiOperationTraitDefinition {
        if(this.operationTraits != null) {
            return /* remove */(map => { let deleted = this.operationTraits[name];delete this.operationTraits[name];return deleted;})(this.operationTraits);
        }
        return null;
    }

    public addServerBindingDefinition(key : string, value : AaiServerBindingsDefinition) {
        if(this.serverBindings == null) this.serverBindings = <any>({});
        /* put */(this.serverBindings[key] = value);
    }

    public addChannelBindingDefinition(key : string, value : AaiChannelBindingsDefinition) {
        if(this.channelBindings == null) this.channelBindings = <any>({});
        /* put */(this.channelBindings[key] = value);
    }

    public addOperationBindingDefinition(key : string, value : AaiOperationBindingsDefinition) {
        if(this.operationBindings == null) this.operationBindings = <any>({});
        /* put */(this.operationBindings[key] = value);
    }

    public addMessageBindingDefinition(key : string, value : AaiMessageBindingsDefinition) {
        if(this.messageBindings == null) this.messageBindings = <any>({});
        /* put */(this.messageBindings[key] = value);
    }

    /**
     * Creates a schema definition.
     * @param {string} name
     * @return {Aai20SchemaDefinition}
     */
    public createSchemaDefinition(name : string) : Aai20SchemaDefinition {
        let rval : Aai20SchemaDefinition = new Aai20SchemaDefinition(name);
        rval._ownerDocument = this._ownerDocument;
        rval._parent = this;
        return rval;
    }
}
AaiComponents["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiComponents";
AaiComponents["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




